import React, { Component } from 'react';
import { getTranslate } from 'react-localize-redux';
import { Checkbox, Form, Input, Radio } from 'antd';
import { connect } from 'react-redux';
import './accountCreation.less';
import Button from '../../components/button/button';
import { tenorOptions, gradeOptions } from '../../common/constants';
import { mapAccountPreferences } from './../account/accountMappers';

@connect(
  ({
    localize,
    accountCreation: { showingAccountCreationModal },
    account: { selectedAccountDetails }
  }) => ({
    translate: getTranslate(localize),
    showingAccountCreationModal,
    selectedAccountDetails
  })
)
@Form.create()
class accountCreation extends Component {
  state = {
    showingAnyAmount: false
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields(
      (err, values) => {
        if (!err) {
          const payload = {}
          this.props.accountId && Object.assign(payload, { lenderAccountId: this.props.accountId })
          Object.assign(payload, values)
          return this.props.action(payload);
        }
      },
      { force: true }
    );
  };

  changeAmountType = anyAmount => e => {
    e.preventDefault();
    this.props.form.resetFields(['minAmount', 'maxAmount']);
    this.setState({
      showingAnyAmount: anyAmount
    });
  };

  triggerMaxAmountValidation = e => {
    const { form } = this.props;
    if (form.isFieldsTouched(['maxAmount'])) {
      form.setFieldsValue({ minAmount: e.target.value });
      form.validateFields(['maxAmount'], { force: true });
    }
  };

  handleLoanAmountChange = (e) => {
    const value = e.target.value
    if (value === 'any') {
      this.props.form.setFieldsValue({ minAmount: '', maxAmount: ''})
    }
  }

  render() {
    const { translate, form, initialValues } = this.props;
    const formInit = mapAccountPreferences(initialValues)
    const { getFieldDecorator } = form;
    const ruleRequired = {
      required: true,
      message: translate('validation.required.default')
    };
    const minAmount = 1000000;

    return (
      <Form
        className={'create-account'}
        layout="vertical"
        onSubmit={this.handleSubmit}
      >
        <Form.Item
          className={'account-name'}
          label={translate('accountCreation.accountName')}
        >
          {getFieldDecorator('name', {
            initialValue: formInit.name,
            rules: [ruleRequired]
          })(<Input disabled={initialValues} className={'no-border'} placeholder={translate('accountCreation.myNewAccount')} />)}
        </Form.Item>
        <Form.Item
          className={'loan-amount-type'}
          label={translate('accountCreation.loanAmount')}
        >
          {getFieldDecorator('loanAmount', {
            onChange: this.handleLoanAmountChange,
            initialValue: formInit.loanAmount
          })(
            <Radio.Group>
              <Radio onClick={this.changeAmountType(false)} value="preferred">
                {translate('accountCreation.preferredAmount')}
              </Radio>
              <Radio onClick={this.changeAmountType(true)} value="any">
                {translate('accountCreation.anyAmount')}
              </Radio>
            </Radio.Group>
          )}
        </Form.Item>
        <Form.Item className={'loan-amount-range unpadded'}>
          <Form.Item className={'min-amount'}>
            {getFieldDecorator('minAmount', {
              validateFirst: true,
              initialValue: formInit.minInvestment,
              rules: this.state.showingAnyAmount
                ? null
                : [
                    ruleRequired, {
                      validator: (rule, value, callback) => {
                        if (+value >= minAmount) {
                          callback()
                        } else {
                          callback(true)
                        }
                      },
                      message: translate('validation.minAmount', {
                        amount: minAmount
                      })
                    }, {
                      validator: (rule, value, callback) => {
                        const error = form.getFieldError('maxAmount');
                        if (error && error[0] === translate('validation.invalidMax')) {
                          callback(true);
                        } else {
                          callback();
                        }
                      },
                      message: translate('validation.invalidMin')
                    }
                  ]
            })(
              <Input
                disabled={this.state.showingAnyAmount}
                onChange={this.triggerMaxAmountValidation}
                placeholder={translate('accountCreation.minAmount')}
                addonBefore="Rp"
                type={'number'}
              />
            )}
          </Form.Item>
          <Form.Item className={'max-amount'}>
            {getFieldDecorator('maxAmount', {
              validateFirst: true,
              initialValue: formInit.maxInvestment,
              rules: this.state.showingAnyAmount
                ? null
                : [
                    ruleRequired,
                    {
                      validator: (rule, value, callback) => {
                        if (+value > +form.getFieldValue('minAmount')) {
                          callback();
                        } else {
                          callback(true);
                        }
                        form.validateFields(['minAmount'], {
                          force: true
                        });
                      },
                      message: translate('validation.invalidMax')
                    }
                  ]
            })(
              <Input
                disabled={this.state.showingAnyAmount}
                placeholder={translate('accountCreation.maxAmount')}
                addonBefore="Rp"
                type={'number'}
              />
            )}
          </Form.Item>
        </Form.Item>
        <Form.Item className={'tenor'} label={translate('accountCreation.tenor')}>
          {getFieldDecorator('tenor', { rules: [ruleRequired], initialValue: formInit.tenor === 'all' ? tenorOptions : formInit.tenor })(
            <Checkbox.Group>
              <Checkbox value="1m">
                {translate('accountCreation.oneMonth')}
              </Checkbox>
              <Checkbox value="3m">
                {translate('accountCreation.months', { value: 3 })}
              </Checkbox>
              <Checkbox value="6m">
                {translate('accountCreation.months', { value: 6 })}
              </Checkbox>
              <Checkbox value="12m">
                {translate('accountCreation.months', { value: 12 })}
              </Checkbox>
            </Checkbox.Group>
          )}
        </Form.Item>
        <Form.Item
          className={'risk-category'}
          label={translate('accountCreation.riskCategory')}
        >
          {getFieldDecorator('riskCategory', { rules: [ruleRequired], initialValue: formInit.riskCategory === 'all' ? Object.keys(gradeOptions) : formInit.riskCategory })(
            <Checkbox.Group>
              <Checkbox value="low">{translate('accountCreation.low')}</Checkbox>
              <Checkbox value="medium">
                {translate('accountCreation.medium')}
              </Checkbox>
              <Checkbox value="high">
                {translate('accountCreation.high')}
              </Checkbox>
            </Checkbox.Group>
          )}
        </Form.Item>
        <Form.Item className={'actions unpadded'}>
          <div className={'footer-note'}>
            <ul>
              <li>{translate('accountCreation.footerNote')}</li>
              <li>{translate('accountCreation.footerNote2')}</li>
            </ul>
          </div>
          <Button
            type="primary"
            htmlType="submit"
            size="large"
          >
            {translate('generic.proceed')}
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

export default accountCreation;
